// Deep-water band along the bottom edge of the board (3D BOARD R3): the sea is level "0"; the
// label shows today's sea level ("Sea level 0" at the start, then 1, 2, 3 after each rise). A soft
// inner shadow on its land side makes the land read as raised above the water.
export default function CoastalRow({ seaLevel = 0, maxLevel = 3, pulse = false }) {
  return (
    <div
      data-testid="coastal-row"
      data-pulse={pulse ? "true" : undefined}
      className={`relative w-full h-full flex items-center justify-between ${pulse ? "sea-pulse" : ""}`}
      style={{ background: "#31697E", boxShadow: "inset 0 10px 10px -6px rgba(15,30,36,0.45)", borderRadius: "0 0 4px 4px", padding: "4px 12px 0", gap: 12, overflow: "hidden" }}
    >
      <div
        data-testid="sea-level-label"
        data-level={seaLevel}
        className="flex items-center min-w-0"
        style={{ color: "var(--on-sea)", gap: 10 }}
        title={`Sea level ${seaLevel}: squares of height ${seaLevel || "–"} or lower flood where the water can reach them`}
      >
        <span data-testid="sea-zero" className="font-coord" title="The sea is level 0" style={{ fontSize: 10, color: "rgba(234,243,246,0.7)" }}>
          0
        </span>
        <span className="flex items-baseline whitespace-nowrap" style={{ gap: 6 }}>
          <span style={{ fontSize: 13.5, fontWeight: 700 }}>Sea level {seaLevel}</span>
          <span className="font-coord" style={{ fontSize: 10.5, color: "var(--on-sea-2)" }}>
            of {maxLevel}
          </span>
        </span>
      </div>
      <div className="truncate" style={{ fontSize: 10.5, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: "var(--on-sea-2)", lineHeight: 1.2 }}>
        Coastline · water spreads by height
      </div>
    </div>
  );
}
